import styled from "styled-components";
import { appear } from "../../constants/animationConstants";

const height = { height: 70 };

export const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 178px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    width: 358px;
    height: 70px;
  }

  @media (min-width: 1440px) {
    margin: 0;
  }
`;

export const Letter = styled.img`
  @media (min-width: 768px) {
    height: 70px;
  }

  @media (min-width: 1440px) {
    animation: ${appear} 0.3s linear 0.5s;
  }
`;

export const LetterK = styled.img`
  @media (min-width: 768px) {
    ${height};
    animation: ${appear} 0.3s linear;
  }
`;

export const LetterI = styled.img`
  @media (min-width: 768px) {
    ${height};
    animation: ${appear} 0.3s linear 0.2s;
  }
`;

export const LetterD = styled.img`
  @media (min-width: 768px) {
    ${height};
    animation: ${appear} 0.3s linear 0.4s;
  }
`;

export const LetterH = styled.img`
  @media (min-width: 768px) {
    ${height};
    animation: ${appear} 0.3s linear 0.6s;
  }
`;

export const LetterA = styled.img`
  @media (min-width: 768px) {
    width: 50px;
    animation: ${appear} 0.3s linear 0.7s;
  }
`;

export const LetterB = styled.img`
  @media (min-width: 768px) {
    ${height};
    animation: ${appear} 0.3s linear 1s;
  }
`;
